// 全局缓存组件
const cacheComponent = {
    state: {
        name: []
    },

    mutations: {
        SET_CACHECOMPONENT_NAME: (state, params) => {
            state.name = params;
        }
    }
}

export default cacheComponent